import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '@/lib/api';

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;

    const track = async () => {
      try {
        await api.post('/analytics/track', {
          path: location.pathname,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent,
        });
      } catch {
        // Silent fail — analytics should never break the site
      }
    };

    track();
  }, [location.pathname]);
}
